import Shipment from './Shipment';

export default Shipment;
